export function easeInOutCubic(t: number): number {
  if (t < 0) return 0;
  if (t > 1) return 1;
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function easeOutCubic(t: number): number {
  if (t < 0) return 0;
  if (t > 1) return 1;
  return 1 - Math.pow(1 - t, 3);
}

export function easeInOutQuad(t: number): number {
  if (t < 0) return 0;
  if (t > 1) return 1;
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

export type EasingFn = (t: number) => number;

export const EASINGS: Record<'easeInOutCubic' | 'easeInOutQuad', EasingFn> = {
  easeInOutCubic,
  easeInOutQuad
};
